/* eslint-disable react/display-name */

import { createTheme } from '@mui/material/styles';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';

const LinkBehavior = forwardRef((props, ref) => {
  const { to, href, ...other } = props;
  if (to || href) {
    return <RouterLink ref={ref} to={to || href} {...other} />;
  } else {
    return <span ref={ref} {...other} />;
  }
});

const theme = {
  palette: {
    primary: {
      main: '#18CC63',
    },
    secondary: {
      main: '#19BB5D',
    },
    link: {
      main: '#18CC63',
    },
    paper: {
      main: '#fff',
    },
  },
  typography: {
    fontFamily: 'Karla, sans-serif',
  },
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      },
    },
    MuiMenuItem: {
      defaultProps: {
        component: LinkBehavior,
      },
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior,
      },
    },
    MuiButton: {
      styleOverrides: {
        contained: {
          color: 'white',
          backgroundColor: 'primary.main',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#1ba755',
            boxShadow: 'none',
          },
          fontSize: '14px',
        },
        outlined: {
          color: 'primary.main',
          borderColor: 'primary.main',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none', // Disable outline when focused
          },
          '& .MuiDataGrid-columnHeader:focus-within': {
            outline: 'none', // Disable outline when clicked
          },
          // Remove outline for checkbox cells
          '& .MuiDataGrid-cell:focus-within': {
            outline: 'none',
          },
          '& .MuiDataGrid-checkboxInput:focus-within': {
            outline: 'none',
          },
        },
      },
    },
  },
};

export default createTheme(theme);
